import * as z$1 from "zod/v4";
//#region src/schemas/open-code-permission.ts
const openCodePermissionActionSchema = z$1.enum([
	"allow",
	"ask",
	"deny"
]);
const openCodePermissionKeySchema = z$1.string().trim().min(1).max(128);
const openCodePermissionPatternSchema = z$1.string().trim().min(1).max(512);
const plainJsonObjectSchema = z$1.custom((value) => typeof value === "object" && value !== null && !Array.isArray(value), "Expected an object");
const openCodePermissionPatternRulesSchema = plainJsonObjectSchema.pipe(z$1.record(openCodePermissionPatternSchema, openCodePermissionActionSchema)).superRefine((value, context) => {
	if (Object.keys(value).length > 128) context.addIssue({
		code: "custom",
		message: "OpenCode permission pattern rules cannot exceed 128 entries"
	});
});
const openCodePermissionConfigSchema = plainJsonObjectSchema.pipe(z$1.record(openCodePermissionKeySchema, z$1.union([openCodePermissionActionSchema, openCodePermissionPatternRulesSchema]))).superRefine((value, context) => {
	if (Object.keys(value).length > 64) context.addIssue({
		code: "custom",
		message: "OpenCode permission config cannot exceed 64 permission keys"
	});
	if (JSON.stringify(value).length > 2e4) context.addIssue({
		code: "custom",
		message: "OpenCode permission config cannot exceed 20 KB"
	});
});
//#endregion
export { openCodePermissionActionSchema, openCodePermissionConfigSchema, openCodePermissionPatternRulesSchema };

//# sourceMappingURL=open-code-permission.js.map